// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios'
import Router, { useRouter } from 'next/router'
import { FC, useEffect, useState } from 'react'
import { Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { Controller, SubmitHandler, useForm } from 'react-hook-form'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import * as yup from 'yup'
import LinkButton from 'components/LinkButton'
import Button from 'components/Button'

import OurClientsInner2 from '../OurClientsInner2'
import {
  SubText,
  TitleH2 as TitleH1,
  TitleH2Styledv2,
  TitleH3,
} from '../Typography'

type FormValues = {
  yourName: string
  yourEmail: string
  phoneInput: string
  skypeID: string
  projectRequirements: string
}
interface CaptchaDetails {
  firstValue?: number
  secondValue?: number
  ans?: number
  isCaptchaMatched?: boolean
}

const BannerSec3: FC<{
  // bannerimg: string
  subTitle: string
  title: string
  blueTitle: string
  blueTitle2: string
  btnText1: string
  btnText2: string
  btnLink: string
  bannerCtaUrl: string
  blueButtonText1: string
  buttonText2: string
}> = ({
  blueTitle,
  blueTitle2,
  title,
  subTitle,
  // bannerimg,
  bannerCtaUrl,
  blueButtonText1,
  buttonText2,
}) => {
  const [captchaDetails, setCaptchaDetails] = useState<CaptchaDetails>({})
  const schema = yup.object().shape({
    yourName: yup.string().max(80).trim().required('Your Name is required'),
    yourEmail: yup
      .string()
      .email('Invalid email format')
      .max(255)
      .required('Your Email is required'),
    projectRequirements: yup
      .string()
      .trim()
      .required('Your Project Requirements is required'),
    // solution: yup
    //   .string()
    //   .required('Captcha is required')
    //   .test('solution', 'Incorrect solution to math sum', (value: string) => {
    //     const solution = parseInt(value, 10)
    //     return solution === captchaDetails.ans
    //   }),
    phoneInput: yup
      .string()
      .test('isValidPhoneNumber', 'Invalid phone number', (value) =>
        value ? isValidPhoneNumber(value) : true
      ),
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
  })

  const [SuccessMesg, setSuccessMesg] = useState('')
  const [ErrorMesg, setErrorMesg] = useState('')
  const [Loading, setLoading] = useState(false)

  const router = useRouter()
  const PageUrl = router.query.path
    ? router.query.path
    : router.pathname.split('/')[1]

  const PageUrlCheck =
    router.query.path === 'react-js-development-services' ||
    router.query.path === 'dot-net-development-company' ||
    router.query.path === 'react-native-app-development' ||
    router.query.path === 'penetration-testing-services' ||
    router.route === '/hire-dedicated-developers' ||
    router.query.path === 'nodejs-development-services'

  const [phoneCountryCode, setPhoneCountryCode] = useState()
  const [formCountryName, setFromCountryName] = useState()

  const onSubmit: SubmitHandler<FormValues> = async (dataFetchPopup) => {
    setLoading(true)
    setSuccessMesg('')
    setErrorMesg('')

    const newComment = {
      name: dataFetchPopup.yourName,
      email: dataFetchPopup.yourEmail,
      skypeId: dataFetchPopup.skypeID,
      contactNumber: dataFetchPopup.phoneInput,
      pro_requirements: dataFetchPopup.projectRequirements,
      pageName: PageUrl,
      countryName: formCountryName,
    }

    try {
      const result = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}/api/user/contactUs/sendInquiry`,
        newComment,
        {
          headers: {
            web_id: 'webcluesinfotech',
          },
        }
      )

      if (result.data.code === 200) {
        setLoading(false)
        setSuccessMesg('Thank you for your message. It has been sent.')
        setTimeout(() => {
          Router.push('/thank-you')
        }, 100)
      } else {
        setLoading(false)
        const objres = {
          result: 'message',
        }
        setErrorMesg(objres.result)
      }
    } catch (error) {
      setLoading(false)
      setErrorMesg('Please try again after sometime')
    }
  }

  const fetchIpLocation = () => {
    ;(async () => {
      await axios.get(`https://ipapi.co/json/`).then((response) => {
        setPhoneCountryCode(response.data.country_code)
        setFromCountryName(response.data.country_name)
      })
    })()
  }

  useEffect(() => {
    fetchIpLocation()
  }, [])
  return (
    <section className="banner_inner banner_inner_new d-flex flex-column justify-content-center">
      <Container className="position-relative">
        <Row className="align-items-center">
          <Col lg={7} xl={7} className="banner_inner_left">
            <TitleH2Styledv2
              className="mb-4 pe-0 pe-xxl-5 me-0 me-xxl-5"
              text={title}
              blueTitle={blueTitle}
              blueTitle2={blueTitle2}
            />
            <SubText
              className="mb-2 pt-2 pe-0 pe-xl-5 me-0 me-lg-5"
              text={subTitle}
            />
            {PageUrlCheck && (
              <div className="mt-3 mt-lg-4 mb-0">
                <LinkButton path="/contact-us" role="button" tabIndex={0}>
                 {blueButtonText1} {buttonText2} 
                </LinkButton>
              </div>
            )}
            {!PageUrlCheck && (
              <div className="mt-3 mt-lg-4 mb-0">
                <LinkButton path={bannerCtaUrl}>
                  {blueButtonText1} {buttonText2} 
                </LinkButton>
              </div>
            )}
          </Col>
          <Col lg={5} xl={5} className="banner_right">
            <section className="contactform_new">
              {/* <img src={bannerimg} className="bi_icon" alt="img" /> */}
              <Container fluid>
                <Row className="justify-content-start">
                  <Col xl={12}>
                    {router.query.path === 'dot-net-development-company' ? (
                      <TitleH3
                        className="text_black "
                        text="Get A Free Quote in 24 Hours or Less!"
                      />
                    ) : router.query.path ===
                      'react-js-development-services' ? (
                      <TitleH3
                        className="text_black"
                        text="Connect With Our Experts"
                      />
                    ) : router.query.path === 'nodejs-development-services' ? (
                      <TitleH3
                        className="text_black"
                        text="Connect With Our Experts"
                      />
                    ) : router.route === '/hire-dedicated-developers' ? (
                      <TitleH3
                        className="text_black"
                        text="Connect With Our Experts"
                      />
                    ) : router.query.path === 'react-native-app-development' ? (
                      <TitleH3
                        className="text_black"
                        text="Schedule A Developer Interview"
                      />
                    ) : PageUrl === 'penetration-testing-services' ? (
                      <TitleH3
                        className="text_black"
                        text="Connect With Our Experts"
                      />
                    ) : (
                      <TitleH1 className="text_black" text="Get in Touch" />
                    )}
                    {router.query.path === 'dot-net-development-company' ? (
                      <SubText className="text_black" text="" />
                    ) : (
                      <SubText
                        className="text_black"
                        text="Fill the form &amp; we will get in touch with you shortly."
                      />
                    )}

                    <div className="mt-4">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="d-flex" />
                        <Row>
                          <Col xl={12} className="mb-2">
                            <Form.Group className="mb-3">
                              <Form.Control
                                type="text"
                                placeholder="Your Name *"
                                className="bg-transparent"
                                {...register('yourName')}
                              />
                              <p className="alert-error">
                                {errors.yourName && (
                                  <span>{errors.yourName.message}</span>
                                )}
                              </p>
                            </Form.Group>
                          </Col>
                          <Col xl={12} className="mb-2">
                            <Form.Group className="mb-3">
                              <Form.Control
                                type="text"
                                placeholder="Your Email *"
                                className="bg-transparent"
                                {...register('yourEmail')}
                              />
                              <p className="alert-error">
                                {errors.yourEmail && (
                                  <span>{errors.yourEmail.message}</span>
                                )}
                              </p>
                            </Form.Group>
                          </Col>
                          <Col xl={6} className="mb-2">
                            <Form.Group className="mb-3">
                              <Controller
                                name="phoneInput"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <PhoneInput
                                    value={value}
                                    onChange={(e: any) => onChange(e)}
                                    defaultCountry={phoneCountryCode}
                                    id="phoneInput"
                                    className="form-control d-flex border-disable bg-transparent"
                                    placeholder="Contact Number"
                                  />
                                )}
                              />
                              <p className="alert-error">
                                {errors.phoneInput && (
                                  <span>{errors.phoneInput.message}</span>
                                )}
                              </p>
                            </Form.Group>
                          </Col>
                          <Col xl={6} className="mb-2">
                            <Form.Group className="mb-3">
                              <Form.Control
                                type="text"
                                placeholder="Skype ID"
                                className="bg-transparent"
                                {...register('skypeID')}
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={12} className="mb-2 pt-3">
                            <Form.Control
                              as="textarea"
                              className="py-0 border-disable bg-transparent"
                              placeholder="Project Requirements *"
                              {...register('projectRequirements')}
                              rows={4}
                            />
                            <p className="alert-error">
                              {errors.projectRequirements && (
                                <span>
                                  {errors.projectRequirements.message}
                                </span>
                              )}
                            </p>
                          </Col>
                          {/* <Col xl={12} className="mt-1">
                            <Form.Group className="pb-1 white_bg_captcha">
                              <Captcha
                                onChange={(val) => setCaptchaDetails(val)}
                              >
                                <Form.Control
                                  type="text"
                                  placeholder="Captcha code"
                                  className="bg-transparent"
                                  {...register('solution')}
                                />
                              </Captcha>
                              <p className="alert-error">
                                {errors.solution && (
                                  <span>{errors.solution.message}</span>
                                )}
                              </p>
                            </Form.Group>
                          </Col> */}
                          <Col xl={12} className="mt-1">
                            <Form.Group className="pb-1 d-none" />
                          </Col>
                          <Col xl={12} className="mt-4">
                            <Button className="btn-black" type="submit">
                              Send Request
                            </Button>
                            {Loading && (
                              <Spinner
                                className="ms-3"
                                animation="border"
                                variant="secondary"
                                role="status"
                                size="sm"
                              />
                            )}
                          </Col>
                          <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-successfully">
                            {SuccessMesg}
                          </p>
                          <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-error">
                            {ErrorMesg}
                          </p>
                        </Row>
                      </form>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </Col>
        </Row>
      </Container>
      <OurClientsInner2 />
    </section>
  )
}

export default BannerSec3
